module.exports = __webpack_public_path__ + "files/60764a7f9e0e345d9d54de2a7a26ab5f.png";